const AERO_REDIRECT_URL_PROD = "https://aerodemo.iq-series.com";
const AERO_REDIRECT_URL_STAGING = "https://aero.staging.iq-series.com";
const AERO_REDIRECT_URL_DEV = "http://aero.dev.iq-series.com";
export const AERO_REDIRECT_URL = process.env.NODE_ENV === 'production' ? AERO_REDIRECT_URL_PROD :
	window.location.hostname.includes('staging') ? AERO_REDIRECT_URL_STAGING :
	AERO_REDIRECT_URL_DEV;